exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/ai-coach-platform.js-WebpackMultiOutput";